export const asUSD = (total: number): string =>
	new Intl.NumberFormat('en-EN', {style: 'currency', currency: 'USD'})
		.format(total);
